import {missionControlFailureFromError} from './mission-control/mission-control-failure'

/**
 * Strip the Web PubSub `access_token` from any string before it is logged or
 * surfaced. Transport errors can embed the full connection URL (which carries
 * `?access_token=…`) in their message, so redact it defensively at the single
 * point where errors become strings.
 */
function redactSecrets(message: string): string {
  return message.replace(/(access_token=)[^&\s"']+/gi, '$1[REDACTED]')
}

export function formatError(err: unknown): string {
  const failure = missionControlFailureFromError(err)
  if (failure) {
    return `Mission Control ${failure.category} failure: status=${failure.status ?? 'none'}, code=${failure.code ?? 'unknown'}${failure.requestId ? `, request_id=${failure.requestId}` : ''}`
  }
  return redactSecrets(err instanceof Error ? err.message : String(err))
}
